import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AdLayer from "../components/AdLayer";

const AdPage = () => {
  return (
    <MasterLayout>
      <AdLayer />
    </MasterLayout>
  );
};

export default AdPage;
